import { IntervalType } from '../types'

export const toNumber = {
  [IntervalType.ANNUALY]: 365,
  [IntervalType.MONTHLY]: 30,
  [IntervalType.QUARTERLY]: 91
}

export default {
  [IntervalType.MONTHLY]: 'Měsíčně',
  [IntervalType.ANNUALY]: 'Ročně',
  [IntervalType.QUARTERLY]: 'Čtvrtletně'
}



// WEBPACK FOOTER //
// ./src/constants/IntervalTypes.tsx